import type {
  ResponseAgentModelCategory,
  ResponseRoomItemModelList,
} from "$/api/server.types";
import type { AgentModel, AgentModelCategory } from "$/domains/agentModel/type";

type ResponseAgentModelItem = ResponseAgentModelCategory["model_items"][number];

/**
 * 将接口返回的单个模型项映射为前端 AgentModel
 */
function formatAgentModelItem(item: ResponseAgentModelItem): AgentModel {
  return {
    modelDesc: item.model_desc,
    modelName: item.model_name,
    modelValue: item.model_value,
    badgeUrl: item.badge_url,
    enable: item.enable,
  };
}

/**
 * 将接口返回的模型分类映射为前端 AgentModelCategory
 */
function formatAgentModelCategory(
  category?: ResponseAgentModelCategory,
): AgentModelCategory {
  return {
    modelCategoryTitle: category?.model_category_title || "",
    modelItems: category?.model_items?.map(formatAgentModelItem) ?? [],
  };
}

/**
 * 将房间模型列表接口数据格式化为前端模型映射
 */
export function modelMapFormat(model: ResponseRoomItemModelList): {
  imageModel: AgentModelCategory;
  videoModel: AgentModelCategory;
  interfaceModel?: AgentModelCategory;
} {
  const { image_model, video_model, interface_model } = model.parameter;

  const modelMap: {
    imageModel: AgentModelCategory;
    videoModel: AgentModelCategory;
    interfaceModel?: AgentModelCategory;
  } = {
    imageModel: formatAgentModelCategory(image_model),
    videoModel: formatAgentModelCategory(video_model),
  };

  if (interface_model) {
    modelMap.interfaceModel = formatAgentModelCategory(interface_model);
  }

  return modelMap;
}

export const modelMapFormatMenuDetail = (model: ResponseRoomItemModelList) => {
  const { model_pattern_info } = model.parameter.menu_detail;
  return model_pattern_info;
};
